import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import caretRight from "../../../../img/misc/caret-right.svg";
import { useAppDispatch, useAppSelector } from "../../../store/reducers";
import { assertNever } from "../../../utils/never";
import { MattressMatchNav } from "../MattressMatchNav";
import { MattressSelectorSize } from "../MattressSize";
import { MattressOption } from "../Option";
import { MattressMatchResults } from "../Results";
import { Step, stepOrder } from "../constants";
import { onNavigate } from "../reducers";

import styles from "./index.module.scss";

export const MattressMatch = (): React.JSX.Element => {
    const mattressMatchUiState = useAppSelector(
        (state) => state.mattressmatch.ui,
    );
    const { currentScreen } = mattressMatchUiState;
    const dispatch = useAppDispatch();
    function buildScreen(step: Step): React.JSX.Element {
        switch (step) {
            case Step.SIZE:
                return <MattressSelectorSize />;
            case Step.RESULTS:
                return <MattressMatchResults />;
            default:
                return <MattressOption step={step} key={step} />;
        }
        assertNever(step as never);
    }

    return (
        <>
            <div className={styles.container} data-screen={currentScreen}>
                {buildScreen(stepOrder[currentScreen])}
                {currentScreen === stepOrder.indexOf(Step.SIZE) && (
                    <div className={styles.buttonContainer}>
                        <button
                            className={styles.button}
                            onClick={() => {
                                dispatch(
                                    onNavigate({
                                        currentScreen: currentScreen + 1,
                                    }),
                                );
                            }}
                        >
                            {t`Get Started`}
                            <SVG src={caretRight} />
                        </button>
                    </div>
                )}
                {currentScreen > stepOrder.indexOf(Step.SIZE) && (
                    <MattressMatchNav />
                )}
            </div>
        </>
    );
};
